import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useRenderBudgetStatusBadge from './hooks/use-render-budget-status-badge';
import {
  BudgetStatusProvider,
  BudgetContext
} from '@ramsey-plus-components/budget-status-ui';

const ENV = {
  development: 'TEST',
  test_one: 'TEST',
  qa: 'QA',
  production: 'PROD'
};

function Badge({ excludedPaths }) {
  const { status } = useContext(BudgetContext);

  if (
    excludedPaths.includes(window.location.pathname) ||
    status === 'CAUGHT UP'
  ) {
    return null;
  }

  return (
    <div
      style={{ width: 10, height: 10 }}
      className="bg-green-40 rounded-full"
    />
  );
}

export default function BudgetStatusBadge({ jwt, excludedPaths }) {
  const environment = ENV[window.PUBLIC_CONSTS.ENVIRONMENT];

  const showBadge = useRenderBudgetStatusBadge();
  if (!showBadge) {
    return null;
  }

  return (
    <BudgetStatusProvider token={jwt} environment={environment}>
      <Badge excludedPaths={excludedPaths} />
    </BudgetStatusProvider>
  );
}

Badge.propTypes = {
  excludedPaths: PropTypes.arrayOf(PropTypes.string)
};

BudgetStatusBadge.propTypes = {
  jwt: PropTypes.string.isRequired,
  excludedPaths: PropTypes.arrayOf(PropTypes.string)
};
